import { InputNumber, Form } from 'antd';

const EditableCell = ({
  editing,
  dataIndex,
  record,
  children,
  onSave,
  onCancel,
  onConfirm,
  ...restProps
}) => {
  return (
    <td
  {...restProps}
  onDoubleClick={() => {
    if (!editing && typeof onConfirm === 'function') {
      onConfirm();
    }
  }}
>
      {editing ? (
        <Form.Item name={dataIndex} style={{ margin: 0 }}>
          <InputNumber
            autoFocus
            style={{ width: '100%' }}
            onPressEnter={() => onSave(record, dataIndex)}
            onBlur={() => onSave(record, dataIndex)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                e.preventDefault();
                onCancel();
              }
            }}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};


export default EditableCell;
